/**
 * @private
 */
const keyMirrorList = (keys = []) => {
  const obj = {}
  const uniqueKeys = new Set(keys)

  for (const key of uniqueKeys) {
    obj[key] = key
  }

  return obj
}

export default keyMirrorList
